import { useFormContext, useFormState, useWatch } from "react-hook-form";

import { RenderElement } from "@up/form";

import { CurrentSchoolCountryName } from "./current-school-country";

export const CurrentSchoolInternationalRegionName =
  "current-school-address-international-region";

export function CurrentSchoolInternationalRegion({
  label = "Current School State/Province/Region",
}: {
  label?: string;
}) {
  const { control, register } = useFormContext();
  const { errors } = useFormState();
  const formValues = useWatch();

  return (
    <RenderElement
      control={control}
      element={{
        _id: CurrentSchoolInternationalRegionName,
        type: "textfield",
        name: CurrentSchoolInternationalRegionName,
        label: label,
        validate: {
          presence: true,
        },
        dependent: {
          dependentName: CurrentSchoolCountryName,
          condition: "notequal",
          conditionValue: "United States",
        },
      }}
      errors={errors}
      formValues={formValues}
      register={register}
      wrapperProps={{ className: "mb-8" }}
    />
  );
}
